import { Component } from '@angular/core';
import { AuditLogService } from './services/auditlog.service';
import { BzgModalService } from 'bz-genome-angular';
import { DetailComponent } from './detail/detail.component';
import { DateUtilDST } from 'app/core/utils/DateUtilDST';

@Component({
  selector: 'biz-auditlog',
  templateUrl: './auditlog.component.html',
  styleUrls: ['./auditlog.component.scss']
})
export class AuditLogComponent {
  selectedCategory: string = '';
  selectedSubcategory: string = '';
  selectedAction: string = '';
  selectedUsername: string = '';

  categories: string[] = [];
  subcategories: string[] = [];
  actions: string[] = [];
  users: string[] = [];
  
  completeDataFilter: any = {};
  completeDataUsers: { [key: string]: string } = {};

  isCollapsed: boolean = false;
  showMessage: boolean = false;
  showMoreMessage: boolean = false;

  dateMin: Date = new Date();
  dateMax: Date = new Date();

  continuationToken: string = '';

  auditLogFilter: IAuditLogFilter;

  logs: any[] = [];

  cellSpacingMode: string = 'normal';
  orderDirection: string = 'desc';
  orderColumnField: string = 'Timestamp';

  constructor(private _auditLogService: AuditLogService, private _modalService: BzgModalService) {
    this.initializeAuditLogFilter();
  }

  ngOnInit(): void {
    this._auditLogService.getFilters().subscribe(data => {
      this.categories = Object.keys(data);
      this.completeDataFilter = data;
    });

    this._auditLogService.getUsers().subscribe(data => {
      this.users = Object.keys(data);
      this.completeDataUsers = data;
    });
  }

  initializeAuditLogFilter() {
    this.dateMin = new Date(this.dateMin.setHours(0, 0, 0, 0));
    this.dateMax = new Date(this.dateMax.setHours(23, 59, 59, 999));
    this.auditLogFilter = {
      filter: {
        pageSize: 40,
        continuationToken: '',
        sort: 'Asc'
      } as IFilterProperties,
      Category: '',
      Subcategory: '',
      Action: '',
      UserName: '',
      StartDate: this.dateMin,
      EndDate: this.dateMax,
    }
  }

  changeCategory(category: string) {
    this.selectedCategory = category;
    this.subcategories = Object.keys(this.completeDataFilter[this.selectedCategory]);
    this.selectedSubcategory = '';
    this.selectedAction = '';
  }

  changeSubcategory(subcategory: string) {
    this.selectedSubcategory = subcategory;
    if (!this.selectedSubcategory) {
      this.actions = [];
      this.selectedAction = '';
      return;
    }

    this.actions = this.completeDataFilter[this.selectedCategory][this.selectedSubcategory];
    this.selectedAction = '';
  }

  changeDatesLog(event) {
    this.dateMin = this.isDate(event.start);
    this.dateMax = this.isDate(event.end);
  }

  isDate(dateInput: Date) {
    if (isNaN(dateInput.getTime())) 
      return new Date();
    else
      return dateInput;
  }

  collapse() {
    this.isCollapsed = !this.isCollapsed;
  }

  disabledButton() {
    return new Date(this.dateMin) > new Date(this.dateMax);
  }

  setClass() {
    return this.isCollapsed ? 'max-height-table' : 'min-height-table';
  }

  getUserByUsername() {
    return this.completeDataUsers[this.selectedUsername];
  }

  cleanFilters() {
    this.selectedCategory = '';
    this.selectedSubcategory = '';
    this.selectedAction = '';
    this.selectedUsername = '';
    this.dateMax = new Date();
    this.dateMin = new Date();
    this.dateMin = new Date(this.dateMin.setHours(0, 0, 0, 0));
    this.dateMax = new Date(this.dateMax.setHours(23, 59, 59, 999));
  }

  getFilesNames(loadMore: boolean) {
    this.auditLogFilter.Category = this.selectedCategory;
    this.auditLogFilter.Subcategory = this.selectedSubcategory;
    this.auditLogFilter.Action = this.selectedAction;
    this.auditLogFilter.UserName = this.getUserByUsername();
    this.auditLogFilter.StartDate = DateUtilDST.convertFromUTC(this.dateMin);
    this.auditLogFilter.EndDate = DateUtilDST.convertFromUTC(this.dateMax);
    this.auditLogFilter.filter.continuationToken = loadMore ? this.continuationToken: null;
      
    this._auditLogService.getAuditLog(this.auditLogFilter).subscribe(data => {
      if (loadMore){
        const logs = [...this.logs, ...data.Results];
        this.logs = [];
        this.logs = logs;
      }
      else
      {
        this.logs = [];
        this.logs = data.Results;
      }
      this.showMoreMessage = data.HasMoreResults;
      this.continuationToken = data.ContinuationToken;
    });
  }
}
